import { getData } from 'services/api';
import { postToast } from 'features/common/utils/postFlash';
import { PAID_COLUMN_DEFS, REGISTRATION_COLUMN_DEFS } from './constants';

const MIN_WIDTH_BY_KEY = new Map<string, number>(
	[...PAID_COLUMN_DEFS, ...REGISTRATION_COLUMN_DEFS].map((def) => [def.key, def.minWidth ?? 120])
);

/**
 * Generates a CSS grid-template-columns string for the PunchupResponsesTable.
 * Each data column gets a `minmax(Npx, 1fr)` track using the column's declared
 * minWidth, guaranteeing the row overflows the container when many columns are
 * present (triggering horizontal scroll) rather than silently collapsing to 1fr.
 * The trailing 80px is the fixed-width sticky actions column.
 *
 * `customHeadings` is accepted for API symmetry with the dark-theme equivalent
 * but is not used — Punchup columns are keyed by string, not positional index.
 */
export const buildGridColumns = (headings: string[], _customHeadings: string[]): string => {
	const dataCols = headings.map((h) => `minmax(${MIN_WIDTH_BY_KEY.get(h) ?? 160}px, 1fr)`).join(' ');
	return `${dataCols} 80px`;
};

export const downloadTicketQR = async (id: number, email: string) => {
	try {
		const response = await getData(`/tickets/${id}/qr`, {
			headers: { 'Content-Type': 'image/png' },
			responseType: 'blob',
		});

		const url = window.URL.createObjectURL(response);
		const a = document.createElement('a');
		a.href = url;
		a.download = (email || 'ticket') + '.png';
		document.body.appendChild(a);
		a.click();
		window.URL.revokeObjectURL(url);
		a.remove();
	} catch {
		postToast('error', 'The ticket QR could not be downloaded. Please try again.');
	}
};

